<script>
import AdminLink from '../components/AdminLink.vue'
import List from '../components/List/List.vue'
export default {
    components:{ AdminLink, List },
    created() {     
        this.$cache.createCache('members', 'members/') 
    },
    data() {
        return { 
                        
        }
    },
    computed: {
        members() {  return this.$store.state.members == null ? [] : this.$store.state.members },
        user() {return this.$store.state.user; },
        customer() {return this.$store.state.customer; },
        columns() {
            var columns = [             
                { name: 'full_name', displayName: 'Namn', width: 400, hideFilter: false}
            ]

            if(!this.customer.disable_user_messages)
            {
                columns.unshift({name: 'send', displayName: 'M', isSendUserMessage: true, align: 'center', width: 30, hideFilter: true, hideIfEdit: true});
            }
            
            if(this.$store.state.settings.UserSetting_form_company_name.enabled)
            {
                columns.push({ name: 'company_name', displayName: 'Företagsnamn', width: 250 });
            }

            columns.push({ name: 'is_active', displayName: 'Är aktiv i jamii', width: 150, hideFilter: true, align: 'center', isBoolean:true});
            
            if(this.customer.customer_type_name != 'Verksamhet')
            {
                columns.push({ name: 'will_not_use_jamii', displayName: 'Medlemmen använder inte Jamii', width: 250, hideFilter: true, isBoolean:true});
            }


            return columns;
        }
    }
}
</script>
<template>
    <AdminLink :buttonText="'Lägg till/ändra ' + this.$store.state.settings.User.plural" :sectionToEdit="'adminMembers'"></AdminLink>
    <List :items="members" :columns="columns" :nameOfItems="this.$store.state.settings.User.plural" :noOfFrozenColumns="this.$isMobile ? 1 : 2" :hideExcelExport="true"></List>           
</template>